import { companyName, formatMoney, formatQty } from '../lib/format';

export default function TopProducts({ topProducts, companyMap }) {
  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Productos más vendidos</h3></div>
      <div className="table-container">
        {topProducts.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📊</div>
            <p>Sin ventas en el periodo</p>
          </div>
        ) : (
          <table>
            <thead><tr><th>Producto</th><th>Tienda</th><th className="num">Cant.</th><th className="num">Ingreso</th></tr></thead>
            <tbody>
              {topProducts.map((p) => (
                <tr key={`${p.companyId}/${p.name}`}>
                  <td className="font-semibold">{p.name}</td>
                  <td className="text-secondary">{companyName(companyMap[p.companyId] || { id: p.companyId })}</td>
                  <td className="num">{formatQty(p.quantity)}</td>
                  <td className="num">{formatMoney(p.revenue, p.currency)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
